module.exports = __webpack_public_path__ + "static/media/feature_redundancy.32e737bb.png";